export function mediaSlider() {
    if (typeof window.Flickity !== 'function') return;

    const sliders = [];
    let disposed = false;
    document.querySelectorAll('[data-media-slider]').forEach((element) => {
        if (window.Flickity.data(element)) return;

        const slider = new window.Flickity(element, {
            cellSelector: '.media__item',
            cellAlign: 'left',
            contain: true,
            freeScroll: true,
            freeScrollFriction: 0.12,
            prevNextButtons: false,
            pageDots: false,
            accessibility: true,
        });

        sliders.push(slider);
        element.querySelectorAll('img').forEach((image) => {
            if (!image.complete) {
                image.addEventListener('load', () => { if (!disposed) slider.resize(); }, { once: true });
            }
        });
    });
    return () => {
        disposed = true;
        sliders.forEach((slider) => slider.destroy());
    };
}
